import styled from 'styled-components';
import Dropdown from 'core/dropdown';
import { pxToRem } from 'utils/convert';

export const Label = styled.div<{ symbolShown: boolean }>`
  white-space: no-wrap;
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: ${pxToRem(20)};
  &:empty {
    margin: 0;
  }
  [data-role='queryBuilder']:not([data-view-mode='true']) & {
    display: none !important;
  }
  font-size: ${({ symbolShown }) =>
    symbolShown ? pxToRem(17) : 'inherit'}; /** css file conversion */
`;

export const StyledCoreDropdown = styled(Dropdown)`
  &&& {
    display: flex;
    width: ${pxToRem(220)}; /** css file conversion */
    height: ${pxToRem(36)};
    flex: 1 1 auto;
    [data-role='queryBuilder'][data-view-mode='true'] & {
      display: none !important;
    }
    &:hover {
      z-index: 1;
    }
  }
`;
